// extracted by mini-css-extract-plugin
export var active = "slider-module--active--439f4";
export var buttonBox = "slider-module--button-box--aeea9";
export var container = "slider-module--container--e969b";
export var dots = "slider-module--dots--6a183";
export var next = "slider-module--next--5fba9";
export var prev = "slider-module--prev--e8881";
export var slickList = "slider-module--slick-list--e10c2";
export var slide = "slider-module--slide--ca24a";
export var sliderNav = "slider-module--slider-nav--6c91e";